import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.Statement {
    & .transactions {
      margin-top: ${spacing(6)};
    }
  }
`
